export default __webpack_public_path__ + "static/media/Logo_black.e9fc6bcb.png";